import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ShoppingCart } from 'lucide-react';
const NAMES = ['María', 'Juan', 'Lucía', 'Carlos', 'Ana', 'Martín', 'Valentina', 'Diego', 'Camila', 'Pablo', 'Florencia', 'Nicolás', 'Sofía', 'Alejandro', 'Carolina', 'Fernando', 'Daniela', 'Sebastián', 'Laura', 'Matías'];
const SURNAMES = ['González', 'Rodríguez', 'López', 'Martínez', 'García', 'Fernández', 'Pérez', 'Romero', 'Díaz', 'Torres', 'Álvarez', 'Ruiz', 'Ramírez', 'Flores', 'Acosta', 'Medina', 'Benítez', 'Herrera', 'Aguirre', 'Cabrera'];
const LOCATIONS = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Formosa', 'San Luis', 'Jujuy', 'Bahía Blanca', 'Posadas', 'Paraná', 'Santiago del Estero', 'Corrientes'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    surname: '',
    location: ''
  });
  useEffect(() => {
    let lastIndex = -1;
    const generateRandomData = () => {
      let newIndex;
      do {
        newIndex = Math.floor(Math.random() * NAMES.length);
      } while (newIndex === lastIndex);
      lastIndex = newIndex;
      setCurrentData({
        name: NAMES[newIndex],
        surname: SURNAMES[Math.floor(Math.random() * SURNAMES.length)],
        location: LOCATIONS[Math.floor(Math.random() * LOCATIONS.length)]
      });
    };
    // Initial delay of 20 seconds
    const initialTimer = setTimeout(() => {
      generateRandomData();
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => setIsVisible(false), 5000);
      // Then start the 45-second interval
      const interval = setInterval(() => {
        generateRandomData();
        setIsVisible(true);
        // Hide after 5 seconds
        setTimeout(() => setIsVisible(false), 5000);
      }, 45000);
      return () => clearInterval(interval);
    }, 20000);
    return () => clearTimeout(initialTimer);
  }, []);
  return <AnimatePresence data-id="element-261">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: -20
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 w-full max-w-[320px] sm:max-w-[350px]" data-id="element-262">
          <div className="bg-[#0f1d36] border border-[#1a2b4c] rounded-xl shadow-2xl p-4 pr-10 relative overflow-hidden" data-id="element-263">
            {/* Subtle gold accent line */}
            <div className="absolute top-0 left-0 w-1 h-full bg-gold-gradient" data-id="element-264" />

            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-[#a0aec0] hover:text-white transition-colors p-1" aria-label="Cerrar notificación" data-id="element-265">
              <X className="w-4 h-4" data-id="element-266" />
            </button>

            <div className="flex items-start gap-3" data-id="element-267">
              <div className="bg-[#d4af37]/10 p-2 rounded-full shrink-0 mt-0.5" data-id="element-268">
                <ShoppingCart className="w-4 h-4 text-[#d4af37]" data-id="element-269" />
              </div>
              <div data-id="element-270">
                <p className="text-sm text-[#e2e8f0] leading-snug" data-id="element-271">
                  <span className="font-bold text-white" data-id="element-272">
                    {currentData.name} {currentData.surname}
                  </span>{' '}
                  de {currentData.location} acaba de comprar el Método Elite AT
                </p>
                <p className="text-xs text-[#a0aec0] mt-1" data-id="element-273">
                  Hace unos instantes
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}